import * as React from 'react';
import { useState, useEffect, useCallback }  from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { app } from '../../config/app.js';
import {  getPermission } from '../../controller/user.js';
import {  getDataByKey } from '../../controller/firestore.js';
import { updateDocToDb } from '../../controller/firestore.js';

import {UserCategoryForm} from '../../config/collections/guide.js'; // Adjust the path as necessary

import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { DateField } from '@mui/x-date-pickers';
import {  Navigate , Link } from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useLocation } from 'react-router-dom';

import Stack from '@mui/material/Stack';

export default function StoricoGuide(props) {
  const user=props.user;
  const collectionName="guide";
  const location=useLocation();
  const httpdata = location.state && location.state.data;
    
  const candidatoData=(httpdata && httpdata.selectedData?httpdata.selectedData:null);
  //console.log("Candidato data",candidatoData);
  const id=(httpdata && httpdata.id?httpdata.id:null);
 // const callerUrl=httpdata.callerUrl;
  const activePermission=getPermission("collection",collectionName,null,user);
  
  const collectionConfig=app.collections_config[collectionName];
  const [docGuida,setDocGuida] =useState({});
  const [errorMessage,setErrorMessage] =useState("");
  const [innerChanged,setInnerChanged]=useState(null);
  const findCandidatoLink="/candidati/";
  //const [candidato,setCandidato]=useState(null);
  const currentPath = location.pathname;
  return (
    <div><Typography sx={{ mb: 2 }} variant="h4">NUOVA GUIDA</Typography>
      {candidatoData === null ? (
        
        <Link to={ findCandidatoLink } state={{ data: { viewAction: 'singleChoice', callbackViewActionUrl:currentPath} }}>
          Cerca candidato
        </Link>
      ) : (
        <div>
          <Typography variant="h6" component="h6"><b>CANDIDATO</b></Typography>
          <Typography sx={{ mb: 2 }} variant="h5">
          {candidatoData.nome} {candidatoData.cognome} (Cat. {app.category[candidatoData.categoria]}) (<Link to={ findCandidatoLink } state={{ data: { viewAction: 'singleChoice', callbackViewActionUrl:currentPath} }}>
          Cambia?
        </Link>)</Typography>
        <div>
        <Typography variant="h6" component="h6"><b>ISTRUTTORE</b></Typography>
            <TextField
                sx={{ mb: 2 }}
                variant="outlined"
                value={docGuida.istruttore}
                onChange={setDocGuida}
                label=""
                type="text"
            />
          </div>
        <div>
        <Typography variant="h6" component="h6"><b>DATA</b></Typography>
            <TextField
                sx={{ mb: 2 }}
                variant="outlined"
                value={docGuida.data}
                onChange={setDocGuida}
                label=""
                type="date"
            />
          </div>
            <UserCategoryForm guida={docGuida} changeGuidaObj={setDocGuida} candidato={candidatoData} />
        </div>
      )}
    </div>
  );
}